/*!
 * _greeting.js
 */
//# =================================================================
//# loadイベント（ready)
//# =================================================================
$(function () {
  grt_002($("section"), "started", false);
  grt_001($("h1.tlt"));
});
//#==================================================================
//# function : grt_001
//# Contents : textillate.jsの動作制御（対象：tltクラスがを持つオブジェクト）
//#            delighters.jsの併用が必要
//# =================================================================
function grt_001(target) {
  target.each(function (i) {
    target
      .eq(i)
      .css("opacity", 1)
      .textillate({
        minDisplayTime: 1000,
        autoStart: true,
        in: {
          effect: "fadeIn",
          // コールバック関数
          callback: function () {
            grt_002($(".detail"), "is-visible", true);
            grt_002($("section"), "started", true);
          },
        },
      });
  });
}
//#==================================================================
//# function : grt_002
//# Contents : addClass/removeClass制御
//# =================================================================
function grt_002(target, clsName, isAdd) {
  if (isAdd) {
    target.addClass(clsName);
  } else {
    target.removeClass(clsName);
  }
}
